/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc Date関連ユーティリティ
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
export default new class {
  /**
   * dateを指定フォーマットに変換します。
   * @param  {Date} date
   * @param  {String} format フォーマット
   * @return {String} フォーマット後の文字列
   */
  formatDate(date, format) {
    format = format || 'YYYY/MM/DD hh:mm:ss.SSS'
    format = format.replace(/YYYY/g, date.getFullYear())
    format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
    format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2))
    format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2))
    format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2))
    format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2))
    if (format.match(/S/g)) {
      const milliSeconds = ('00' + date.getMilliseconds()).slice(-3)
      const length = format.match(/S/g).length
      for (let i = 0; i < length; i++) {
        format = format.replace(/S/, milliSeconds.substring(i, i + 1))
      }
    }
    return format
  }

  /**
   * 生年月日選択リスト‐年のリストを取得
   * @param  {String} startYear
   * @return {List}
   */
  getYears(startYear) {
    let years = []
    let currentYear = (new Date()).getFullYear()
    for (let i = startYear; i < currentYear + 1; i++) {
      years.push({
        value: i,
        label: i
      })
    }
    return years
  }

  /**
   * 生年月日選択リスト‐月のリストを取得
   * @return {List}
   */
  getMonths() {
    let months = []
    for (let i = 1; i < 13; i++) {
      months.push({
        value: i,
        label: i
      })
    }
    return months
  }

  /**
   * 生年月日選択リスト‐日のリストを取得
   * @param {String} year
   * @param {String} month
   * @return {List}
   */
  getDays(year, month) {
    let lastDays = ['', 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
      lastDays[2] = 29
    }
    let lastDay = lastDays[month]
    if (lastDay == null) {
      lastDay = 31
    }
    let days = []
    for (let i = 1; i < lastDay + 1; i++) {
      days.push({
        value: i,
        label: i
      })
    }
    return days
  }
}()



// WEBPACK FOOTER //
// ./src/utils/DateUtil.js